import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type Props = {};

const SiteTrustedCustomersComponent = (props: Props) => {
  const { t } = useTranslation();

  return (
    <section id="trusted-customers ">
      <Container>
        <Row className="pt-5 pb-3">
          <Col className="d-flex  align-items-center gap-2 justify-content-center text-center">
            <hr style={{ flex: "1" }} className="d-none d-lg-block" />
            <hr style={{ width: "20px" }} className="d-lg-none" />
            <h2 style={{ flex: "1" }} className="d-none d-lg-block">
              {t("home/SiteTrustedCustomers/title")}
            </h2>
            <h2 className="d-lg-none">
              {t("home/SiteTrustedCustomers/title")}
            </h2>
            <hr style={{ width: "20px" }} className=" d-lg-none" />
            <hr style={{ flex: "1" }} className="d-none d-lg-block" />
          </Col>
        </Row>
        <Row>
          <Col className="tw-flex tw-flex-col">
            <div className="tw-flex tw-items-center tw-justify-center tw-gap-5 tw-flex-wrap">
              <div>
                <img
                  loading="lazy"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23091908442327_Google.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23091908442349_Zapier.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23091908442328_Microsoft.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23091908442381_NVIDIA.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/2309190844239_HP.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/2309190844239_MSL.svg"
                  crossOrigin="anonymous"
                />
              </div>
            </div>
            <div className="tw-flex tw-items-center tw-justify-center tw-gap-5 tw-mt-5 tw-flex-wrap">
              <div>
                <img
                  loading="lazy"
                  className="tw-w-[120px] "
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23100109500528_IBM.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  className="tw-w-[120px]"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23072206201651_lumberJack.png"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  className="tw-w-[120px]"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23092010335472_Meta.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  className="tw-w-[120px]"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23092010335553_Open_AI.svg"
                  crossOrigin="anonymous"
                />
              </div>
              <div className="tw-w-[120px] tw-h-[60px] tw-flex tw-justify-center tw-items-center">
                <img
                  loading="lazy"
                  className="tw-h-[45px] tw-mb-2"
                  src="https://cdn.1cdn.app/application/LOUISEBOT/23103108360738_Prodins_2_%281%29.svg"
                  crossOrigin="anonymous"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteTrustedCustomersComponent;
